module.exports = __webpack_public_path__ + "static/Buddha2-4d15c552d3abcd26cf7246aaf429082c.png";